import { render, staticRenderFns } from "./UserRoleEditDialog.vue?vue&type=template&id=bfeb6cbe&scoped=true"
import script from "./UserRoleEditDialog.vue?vue&type=script&lang=js"
export * from "./UserRoleEditDialog.vue?vue&type=script&lang=js"
import style0 from "./UserRoleEditDialog.vue?vue&type=style&index=0&id=bfeb6cbe&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfeb6cbe",
  null
  
)

export default component.exports